<template>
	<h1>System Configuration</h1>
	<!-- <BaseSelect1
        :options="options"
        label="Zeebrals"
        name="zeb_name"
        v-model="zeeb"
    /> -->
	<div class="col-4">
		<MultiSelect />
	</div>
</template>

<script>
	import { reactive } from "vue";
	import BaseSelect1 from "@/components/BaseSelect1";
	import MultiSelect from "@/components/Multiselect";

	export default {
		name: "TheConfig",
		components: {
			BaseSelect1,
			MultiSelect,
		},
		setup: () => {
			//
			const zeeb = reactive({});
			var options = reactive([
				{ id: "123qwe", name: "Tommy" },
				{ id: "098oiu", name: "Shelby" },
				{ id: "irur8ru", name: "Joker" },
			]);
			return { options, zeeb };
		},
	};
</script>
